import { OrganizationDto } from "@merchant_api/models/organization-dto";

export class MerchantState {
    loading = false;
    error = null;
    merchant?: OrganizationDto;
}

